import { rouletteApiGet } from './roulette-api';
import type { ApiFetchRoulettesPort } from '~/handlers/ports/api-fetch-roulettes.port';
import type { RouletteListResult } from '~/types/roulette';

export class ApostatudoApiFetchRoulettesAdapter
  implements ApiFetchRoulettesPort
{
  async handle(): Promise<RouletteListResult> {
    const json = await rouletteApiGet('/roulettes');

    return {
      data: (json.data ?? []).map((item: any) => ({ slug: item.slug })),
    };
  }
}
